import bem from 'utils/bem';

export const block = bem('create-tab-card');
